const REPORT_FIELDS = [
  'voice-report', 'result', 'phase', 'source', 'bytes', 'requested', 'codec',
  'permission', 'inputRate', 'inputChannels', 'muted', 'muteEvent', 'seconds',
  'level', 'stop', 'rms', 'peak', 'offset', 'decodedSeconds', 'channel', 'channels',
  'decodedRate', 'native', 'wav', 'path', 'gain', 'upload', 'uploadBytes', 'asrHttp', 'http',
];

// Retire old investigation links before React Router/auth reads the location.
// Do not reload, clear site storage, or alter OAuth/session callback fragments.
export function retireVoiceDiagnostics() {
  try {
    delete window.__ttsVoiceBuild;
    delete window.__ttsVoiceDiagnostics;
    const url = new URL(window.location.href);
    let changed = false;
    if (url.searchParams.has('voice-check')) { url.searchParams.delete('voice-check'); changed = true; }
    const fragment = new URLSearchParams(url.hash.slice(1));
    if (url.hash.startsWith('#voice-report=') && !fragment.has('session_id')) {
      REPORT_FIELDS.forEach(field => fragment.delete(field));
      url.hash = fragment.toString(); changed = true;
    }
    if (changed) window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
  } catch { /* Optional link cleanup must not interfere with capture or login. */ }
}